/**
 * Full-viewport loading overlay while Phaser boots World / Hud / Ui.
 */

let hideResolve: (() => void) | null = null;
let readyPromise: Promise<void> | null = null;

function els() {
  return {
    root: document.getElementById('game-loading'),
    status: document.getElementById('game-loading-status'),
    fill: document.getElementById('game-loading-bar-fill'),
    bar: document.getElementById('game-loading-bar'),
  };
}

export function showGameLoading(status = 'Preparing your smash adventure…') {
  const { root, status: statusEl, fill, bar } = els();
  if (!root) return;

  root.classList.remove('game-loading--hidden');
  root.classList.add('game-loading--visible');
  root.setAttribute('aria-busy', 'true');
  if (statusEl) statusEl.textContent = status;
  if (fill) fill.style.width = '0%';
  if (bar) bar.setAttribute('aria-valuenow', '0');

  readyPromise = new Promise<void>((resolve) => {
    hideResolve = resolve;
  });
}

export function updateGameLoadingProgress(ratio: number, status?: string) {
  const { status: statusEl, fill, bar } = els();
  const pct = Math.max(0, Math.min(100, Math.round(ratio * 100)));
  if (fill) fill.style.width = `${pct}%`;
  if (bar) bar.setAttribute('aria-valuenow', String(pct));
  if (status && statusEl) statusEl.textContent = status;
}

export function hideGameLoading() {
  const { root } = els();
  if (root) {
    root.classList.remove('game-loading--visible');
    root.classList.add('game-loading--hidden');
    root.setAttribute('aria-busy', 'false');
  }
  if (hideResolve) {
    hideResolve();
    hideResolve = null;
  }
}

/** Resolves when BootScene signals the world UI is ready (or immediately if already past boot). */
export function waitForGameReady() {
  return readyPromise ?? Promise.resolve();
}

export function signalGameReady() {
  updateGameLoadingProgress(1, 'Ready!');
  // Brief beat so the bar can settle before the fade-out.
  window.setTimeout(() => hideGameLoading(), 180);
}
